import React from 'react';
import { Card } from './ui/card';
import { testimonials } from '../data/mock';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 sm:py-32 bg-[#0A0A0A] relative overflow-hidden">
      {/* Subtle texture overlay */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("https://static.prod-images.emergentagent.com/jobs/e8cf70d2-e53e-4ea5-b12f-f14ccb00398e/images/27fd32ee507cc80c9da576361c150dbed04e23a5607195a3334244f8c3a25242.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block text-[#D4A520] font-medium text-sm uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Testimonios
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 tracking-tight">
            Lo que dicen nuestros clientes
          </h2>
          <div className="w-16 h-[1px] bg-[#D4A520] mx-auto mb-6" />
          <p className="text-white/40 text-base max-w-2xl mx-auto" style={{ fontFamily: 'Outfit, sans-serif' }}>
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              data-testid={`testimonial-card-${testimonial.id}`}
              className="relative p-8 bg-[#1A1A1A] border border-[#D4A520]/10 rounded-none hover:border-[#D4A520]/30 transition-all duration-500 group"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-6 w-10 h-10 bg-[#D4A520] flex items-center justify-center">
                <Quote className="w-5 h-5 text-black" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4 mt-2">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#D4A520] text-[#D4A520]" />
                ))}
              </div>

              {/* Text */}
              <p className="text-white/60 leading-relaxed mb-6 italic" style={{ fontFamily: 'Outfit, sans-serif' }}>
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 border border-[#D4A520]/30 flex items-center justify-center">
                  <span className="text-[#D4A520] font-bold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-sm text-white/30 uppercase tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>Cliente Satisfecho</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
